import { downloadSourceFile } from "../../../../actions/Utilities/Common";
import DownloadButton from "../../../../components/DownloadButton";
import { toast } from "../../../../components/toastNotification";

const AgmtAttachment = ({ sourceFile }) => {
  const downloadFile = (fileName) => {
    try {
      downloadSourceFile(fileName).then((content) => {
        if (content.status === 200) {
          var url = window.URL.createObjectURL(content.data);
          let tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
          toast.fire("Success", "File Downloaded Successfully", "success");
        }
        if (content.status === 404) {
          toast.fire("Error Downloading File:", "File not found", "error");
        }
      });
    } catch (error) {
      toast.fire(
        "Failed to Download File",
        "Server Error: Cannot download file due to: " + error,
        "error"
      );
    }
  };
  return (
    <>
      {sourceFile ? (
        <div className="px-4 text-xs">
          <div className="p-2 bg-LightWhite flex justify-between items-center space-x-4">
            <div className="">{sourceFile}</div>
            <div className="">
              <DownloadButton
                buttonValue="Download"
                onClick={() => {
                  downloadFile(sourceFile);
                }}
                className={undefined}
                disabled={false}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex justify-center text-xs italic col-span-3">
          No Attachment Found
        </div>
      )}
    </>
  );
};

export default AgmtAttachment;
